<div [style]="{position:'relative', height:'100%', width:'100%'}">
	<div  #elem id="{{map}}" class="map" [style]="{height:'100%', width:'100%'}"></div>
</div>


<div [style]="{position:'absolute',top:'10px',right:'10px',zIndex: 10}" >
		
		<div class="toolSelectHolder">
		<a class="t1 active_{{areaToolEnabled}}"   (click)="toolSelect(measureoptions[0])"  pTooltip="Merjenje površine" tooltipPosition="left" tooltipZIndex="10"></a>
		<br><br>
		<a class="t2 active_{{lengthToolEnabled}}"   (click)="toolSelect(measureoptions[1])"  pTooltip="Merjenje dolžine" tooltipPosition="left" tooltipZIndex="10"></a>
		<br><br>		
		<a class="t3 active_{{panToolEnabled}}"  (click)="toolSelect(measureoptions[2])" pTooltip="Premik karte" tooltipPosition="left" tooltipZIndex="10"></a>
		</div>
</div>		
 
<div *ngIf = "(maptype === 'HYBRID')" class="vectorMap" (click)="mapSelect('NORMAL')" tooltipZIndex="99999" pTooltip="Karta" tooltipPosition="left"></div>
<div *ngIf = "(maptype === 'NORMAL')" class="hybridMap" (click)="mapSelect('HYBRID')" tooltipZIndex="99999" pTooltip="Hibridna karta" tooltipPosition="left"></div>
	

	
	
<div class="messureValueContainer">
    <div class="pane" >
		<samp id="js-result"> </samp>
	</div>
</div>	



 